// extracted by mini-css-extract-plugin
export default {"globalDropdown":"dropdown_globalDropdown__vS4Mj"};